import { FieldTypeAsset } from '@allesauto/utils/consts';
import { createMarkup } from '@allesauto/utils/funcs';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React from 'react';

import NextImage from '../nextImage';

export interface HeroStageProps {
  headline: string;
  imageDesktop: FieldTypeAsset;
  imageMobile: FieldTypeAsset;
  component: string;
  _uid: string;
  _editable?: string;
}

const HeroStage: React.FC<HeroStageProps> = (props) => {
  const { headline, imageDesktop, imageMobile } = props;
  const className = {
    wrapper: clsx(
      'aspect-square bg-transparent grid grid-cols-24 grid-rows-1 w-full lg:aspect-[2/1] lg:relative'
    ),
    headline:
      'lg:absolute md:mb-60px lg:bottom-1/4 lg:translate-y-1/4 font-headline col-end-24 text-title col-start-2 lg:col-end-12 mb-40px lg:mb-0 self-end z-40 row-span-full text-green60 monochrome:text-black',
    image: 'col-span-full row-span-full z-30 relative',
    visibleOnMobile: 'block lg:hidden',
    visibleOnDesktop: 'hidden lg:block',
  };

  return (
    <div {...sbEditable(props)} className={className.wrapper}>
      <div
        className={className.headline}
        dangerouslySetInnerHTML={createMarkup(headline)}
      ></div>
      <div className={className.image}>
        <NextImage
          useCustomLoader={false}
          alt={imageMobile.alt}
          src={imageMobile.filename}
          layout="fill"
          objectFit="cover"
          objectPosition="20% center"
          quality={50}
          priority={true}
          className={className.visibleOnMobile}
        />
        <NextImage
          useCustomLoader={false}
          alt={imageDesktop.alt}
          src={imageDesktop.filename}
          layout="fill"
          objectFit="cover"
          objectPosition="20% center"
          quality={75}
          priority={true}
          className={className.visibleOnDesktop}
        />
      </div>
    </div>
  );
};

export default HeroStage;
